/**
 * DanosVigentesApiClient -- los danos del periodo uno por uno, con su compensacion (INV-CRUCES-PRESENTACION-T1, D-138).
 *
 * Contrato CONFIRMADO por A en la bitacora #30141 (propuesto por P en #30139): GET
 * /api/v1/negocios/{businessId}/danos-vigentes?desde&hasta sobre nexo_private.v_danos_vigentes (nexo-api 566).
 * Data = { items: [{ fechaOperativa, insumo, unidadesOriginal, unidadesCompensadas, unidadesVigentes, valorOriginal,
 * valorVigente, estado, colaborador?, cruces: [...] }], totalVigente, totalOriginal }.
 *
 * FAIL-OPEN: mientras la ruta no este publicada devuelve un motivo legible (NO_PUBLICADO) y la vista lo dice; el dia que
 * A la sirva, se enciende sola sin re-deploy del panel.
 *
 * @module infrastructure/api/DanosVigentesApiClient
 */

import { ApiBase } from './ApiBase.js';

export const DanosVigentesApiClient = {
  /** Nunca lanza. @returns {Promise<{ok:boolean, data?:object, motivo?:string}>} */
  async get(businessId, { desde, hasta } = {}) {
    if (!businessId) return { ok: false, motivo: 'SIN_NEGOCIO' };
    const qs = new URLSearchParams();
    if (desde) qs.set('desde', desde);
    if (hasta) qs.set('hasta', hasta);
    let res;
    try {
      res = await ApiBase.get(`/api/v1/negocios/${encodeURIComponent(businessId)}/danos-vigentes${qs.toString() ? '?' + qs : ''}`);
    } catch {
      return { ok: false, motivo: 'SIN_RED' };
    }
    if (res.ok) return { ok: true, data: res.data?.data ?? res.data ?? {} };
    // ApiBase deja el status en res.code (CrudResult.fail); el texto queda de respaldo.
    const code = String(res.code ?? '');
    const txt = JSON.stringify(res.error || '');
    if (code === '404' || /not\s*found|404/i.test(txt)) return { ok: false, motivo: 'NO_PUBLICADO' };
    if (code === '401' || code === 'UNAUTHORIZED' || /401|unauthor/i.test(txt)) return { ok: false, motivo: 'SIN_SESION' };
    if (code === '403' || /403|forbidden/i.test(txt)) return { ok: false, motivo: 'PROHIBIDO' };
    return { ok: false, motivo: 'ERROR_API' };
  }
};
